const namesFr = [
    'M-J', 'Piaf', 'Brel', 'Daft', 'Abba', 'Bowi', 'Jimi', 'Cher',
    'Pink', 'Sia', 'Ozzy', 'Bono', 'Nina', 'Amy', 'Iggy', 'Sade',
    'Jul', 'Aya', 'Ange', 'Ella', 'Moby', 'Beck', 'Kurt', 'Nino',
];

const namesEn = [
    'M-J', 'Bowi', 'Jimi', 'Daft', 'Abba', 'Cher', 'Pink', 'Sia',
    'Ozzy', 'Bono', 'Nina', 'Ella', 'Amy', 'Iggy', 'Sade', 'Moby',
    'Beck', 'Kurt', 'Mick', 'Tina', 'Adel', 'Ray', 'Duke', 'Jay',
];

export const getRandomPseudo = (language: 'fr' | 'en'): string => {
    const names = language === 'fr' ? namesFr : namesEn;
    return names[Math.floor(Math.random() * names.length)];
};
